import React from "react";

const Loading = () => {
    return (
        <>
            <article className="loading">
                <div className="abc">Loading...</div>
            </article>
        </>
    );
};

export default Loading;
